import React from "react";
import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import { FaEye, FaFileDownload } from "react-icons/fa";
import NoData from "../../../../atoms/NoData";
import Button from "../../../../atoms/Button";

const DeletedDocumentsTable = ({
    eliminados,
    loading,
    loading2,
    expandedRowKeyDeleted,
    handleRowExpandToggledDeleted,
    handleOpenDocument,
    handleDownloadDocument,
}) => {
    const conditionalRowStylesDeleted = [{ when: row => row?.key === expandedRowKeyDeleted, style: { backgroundColor: '#f3f4f6', }, },];

    const columnsEliminados = [
        { name: "Fecha de los documentos", selector: row => row.fecha },
        { name: "Tipo de archivo(s)", selector: row => row.types },
        {
            name: "Nombre(s) de archivo(s)",
            selector: row =>
                row.archivos?.filter(file => file.activo && file.title)?.map(file => file.title)?.join(", ") || "Sin archivos",
            wrap: true,
        },
    ];

    const columnsEliminadosResponsive = [
        {
            name: "Información",
            cell: row => (
                <div className="flex flex-col space-y-2">
                    <div><strong>Fecha:</strong> {row.fecha}</div>
                    <div><strong>Tipo(s):</strong> {row.types}</div>
                    <div>
                        <strong>Archivo(s):</strong>{" "}
                        {row.archivos?.filter(file => file.activo && file.title)
                            ?.map(file => file.title)
                            ?.join(", ") || "Sin archivos"}
                    </div>
                </div>
            ),
            wrap: true,
        },
    ];

    return (
        <div>
            <div className="block lg:hidden">
                <DataTable
                    data={eliminados}
                    columns={columnsEliminadosResponsive}
                    progressPending={loading}
                    progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                    noDataComponent={<NoData />}
                    pagination
                    expandableRows
                    expandableRowExpanded={row => row.key === expandedRowKeyDeleted}
                    onRowExpandToggled={handleRowExpandToggledDeleted}
                    conditionalRowStyles={conditionalRowStylesDeleted}
                    expandableRowsComponent={({ data }) => {
                        const archivosInactivos = data?.archivos?.filter(file => !file.activo);
                        return (
                            <div className="border border-gray-200 border-t-0 rounded-b-xl mb-1">
                                <DataTable
                                    data={archivosInactivos}
                                    columns={getColumnsArchivosEliminadosResponsive(loading2, handleOpenDocument, handleDownloadDocument)}
                                    progressPending={loading}
                                    progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                                    noDataComponent={<NoData />}
                                />
                            </div>
                        );
                    }}
                />
            </div>
            <div className="hidden lg:block">
                <DataTable
                    data={eliminados}
                    columns={columnsEliminados}
                    progressPending={loading}
                    progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                    noDataComponent={<NoData />}
                    pagination
                    expandableRows
                    expandableRowExpanded={row => row.key === expandedRowKeyDeleted}
                    onRowExpandToggled={handleRowExpandToggledDeleted}
                    conditionalRowStyles={conditionalRowStylesDeleted}
                    expandableRowsComponent={({ data }) => {
                        const archivosInactivos = data?.archivos?.filter(file => !file.activo);
                        return (
                            <div className="border border-gray-200 border-t-0 rounded-b-xl mb-1">
                                <DataTable
                                    data={archivosInactivos}
                                    columns={getColumnsArchivosEliminados(loading2, handleOpenDocument, handleDownloadDocument)}
                                    progressPending={loading}
                                    progressComponent={<div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div>}
                                    noDataComponent={<NoData />}
                                />
                            </div>
                        );
                    }}
                />
            </div>
        </div>
    );
};

export default DeletedDocumentsTable;

// Funciones para definir las columnas de archivos eliminados (reutilizables)
const getColumnsArchivosEliminados = (loading2, handleOpenDocument, handleDownloadDocument) => [
    { name: "Nombre", selector: row => row.title || "No hay archivo cargado" },
    { name: "Tipo de archivo", selector: row => row.typeFile },
    { name: "Actualizó", selector: row => row.user },
    {
        name: "Acciones", cell: row => (
            <div className="flex flex-row space-x-4">
                <Button text={<FaEye size={22} />} bgColor="blue" width="w-10" onClick={() => handleOpenDocument(row.s3Key, row.typeFile)} disabled={loading2} />
                <Button text={<FaFileDownload size={22} />} bgColor="green" width="w-10" onClick={() => handleDownloadDocument(row.s3Key)} disabled={loading2} />
            </div>
        )
    },
];

const getColumnsArchivosEliminadosResponsive = (loading2, handleOpenDocument, handleDownloadDocument) => [
    {
        name: "Archivos", cell: row => (
            <div className="w-full flex flex-col">
                <p> {row.title || "No hay archivo cargado"} </p>
                <p> Tipo: {row.typeFile} </p>
                <p> Actualizó {row.user} </p>
                <div className="w-full flex flex-row justify-around">
                    <Button text={<FaEye size={22} />} bgColor="blue" width="w-10" onClick={() => handleOpenDocument(row.s3Key, row.typeFile)} disabled={loading2} />
                    <Button text={<FaFileDownload size={22} />} bgColor="green" width="w-10" onClick={() => handleDownloadDocument(row.s3Key)} disabled={loading2} />
                </div>
            </div>
        )
    },
];